import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useWorkspaceTypes } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props extends Omit<SelectProps<number>, 'items' | 'onSelect'> {
  onChange?: (value: number) => void
}
const WorkspaceType = (props: Props) => {
  const { onChange, ...otherProps } = props

  const types = useWorkspaceTypes()

  const items = types.data?.map((type) => ({
    value: type.id,
    title: type.name,
  }))

  return (
    <Select
      style={styles.container}
      onSelect={onChange}
      items={items}
      testID="WorkspaceType.Container"
      {...otherProps}
    />
  )
}

export default WorkspaceType
